import React from 'react';

type Props<T> = {
    readonly product: T;
    readonly onRemoveProductFromList: (product: T) => void;
};

export default class RemoveFromProductlistButton<T> extends React.Component<Props<T>> {
    render() {
        return (
            <div className="default-dd-nav expanded-dd actions fl-left">
                <a className="bt-dd" onClick={() => this.props.onRemoveProductFromList(this.props.product)}>
                    <i className="material-icons up">delete</i>
                </a>
            </div>
        );
    }
}

(RemoveFromProductlistButton as any).defaultProps = {
    product: {},
    onRemoveProductFromList: () => {}
};
